import { Component, DOCUMENT, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ENV } from '@bodyanalytics/app-config';
import { RouterUrlsEnum } from '../../enums/router-urls.enum';

@Component({
  standalone: true,
  selector: 'bodyanalytics-admin-member-button',
  templateUrl: './admin-button.component.html',
  styleUrls: ['./admin-button.component.scss'],
})
export class AdminMemberButtonComponent {
  private router = inject(Router);
  private document = inject<Document>(DOCUMENT);
  private appConfig = inject(ENV);

  dashboard() {
    this.router.navigateByUrl(`${RouterUrlsEnum.AUTH_ADMIN_DASHBOARD}`);
  }
  goToPortal() {
    this.document.location.href = `${this.appConfig.stripePlanUrl}`;
  }

  goToRegistration() {
    this.router.navigateByUrl(`${RouterUrlsEnum.AUTH_ADMIN_REGISTER}`);
  }
}
